/**
 * @generated SignedSource<<40efdce891249167b1ca3c3e3fa97483>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DocumentMutationsDeleteDocumentMutation$variables = {
  id: string;
};
export type DocumentMutationsDeleteDocumentMutation$data = {
  readonly deleteDocument: {
    readonly id: string;
  };
};
export type DocumentMutationsDeleteDocumentMutation = {
  response: DocumentMutationsDeleteDocumentMutation$data;
  variables: DocumentMutationsDeleteDocumentMutation$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'id',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'id',
            variableName: 'id',
          },
        ],
        concreteType: 'Document',
        kind: 'LinkedField',
        name: 'deleteDocument',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'id',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'DocumentMutationsDeleteDocumentMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'DocumentMutationsDeleteDocumentMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '4c9912ecddb3263d64648a3c0cb3f880',
      id: null,
      metadata: {},
      name: 'DocumentMutationsDeleteDocumentMutation',
      operationKind: 'mutation',
      text: 'mutation DocumentMutationsDeleteDocumentMutation(\n  $id: ID!\n) {\n  deleteDocument(id: $id) {\n    id\n  }\n}\n',
    },
  };
})();

(node as any).hash = '913d16561742c616a919ed19cba17a97';

export default node;
